<template>
	<v-container>
		<v-card>
			<v-card-title>
				<strong><translate>Unprocessed Payments</translate></strong>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col>
						<model-backend-table
							endpoint="/api/v0/payments?processed=0&paymenttype_id=5"
							:headers="
								tableHeaders"
							:items-per-page-options="[ 25, 50, 100, ]"
						>
							<template #item.invoiceId="{ item }">
								<a
									:href="`/bo/invoices/view?id=${item.invoiceId}`"
								>
									{{ item.invoiceId }}
								</a>
							</template>
							<template #item.amount="{ item }">
								{{ transformToCurrency(item.amount) }}
							</template>
						</model-backend-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'UnprocessedPaymentOverview',
	data () {
		return {
		};
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: this.$gettext('Invoice Id'), value: 'invoiceId', sortable: false,
				},
				{
					title: this.$gettext('Book Date'), value: 'bookDate', sortable: false,
				},
				{
					title: this.$gettext('Created'), value: 'createdAt', sortable: false,
				},
				{
					title: this.$gettext('Amount'), value: 'amount', sortable: false,
				},
			];
		}
	},
	methods: {
		/**
		 * @param {string} amount
		 * @returns {string}
		 */
		transformToCurrency (amount) {
			const eurFormatter = new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'EUR',
			});

			return eurFormatter.format(Number(amount));
		},
	},
};
</script>
